<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Les Classeurs</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard' }">Tableau de bord</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <router-link :to="{ name: 'classeurs' }">Les Classeurs</router-link>
          </li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h3 class="card-title fw-bold mb-0">Détail PTA : {{ id }}</h3>
            <button class="btn btn-outline-primary btn-sm" @click="goBack">
              <i class="fe fe-arrow-left me-1"></i> Retour
            </button>
          </div>
          <div class="card-body">
            <div class="panel panel-primary">
              <div class="tab-menu-heading tab-menu-heading-boxed">
                <div class="tabs-menu-boxed">
                  <!-- Tabs -->
                  <ul class="nav panel-tabs">
                    <li><a href="#livrables" class="active" data-bs-toggle="tab">Livrables</a></li>
                    <li><a href="#points-durs" data-bs-toggle="tab">Points durs</a></li>
                    <li><a href="#risques" data-bs-toggle="tab">Risques</a></li>
                    <li><a href="#retards" data-bs-toggle="tab">Retards</a></li>
                  </ul>
                </div>
              </div>
              <div v-if="pta" class="panel-body tabs-menu-body">
                <div class="tab-content">
                  <div class="tab-pane active" id="livrables">
                    <div class="card">
                      <div class="card-header">
                        <h3 class="card-title">Liste des livrables</h3>
                        <div class="card-options">
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm" @click.prevent="addLivrable(null)"><i class="fe fe-plus-circle"></i>
                              Creer<span class="caret"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        <GenericDataTable
                            ref="tableLivrableRef"
                            apiEndpoint="/livrables/page"
                            :columns="livrableColumns"
                            :filterableFields="livrableFilterableFields"
                            :rowActions="livrableRowActions"
                            :search-field="'nom'"
                            :defaultFilters="{ idPtaId: pta.id }"
                            @edit="editLivrable"
                            @drop="dropLivrable"
                        >

                          <template #cell-pole="{ item }">
                            {{ item.pole?.nomPole || '-' }}
                          </template>
                          <template #cell-pointFocalAbin="{ item }">
                            {{ item.pointFocalAsin ? item.pointFocalAsin.nom + ' ' + item.pointFocalAsin.prenom : '-' }}
                          </template>
                          <template #cell-referencePmo="{ item }">
                            {{ item.referentPmo ? item.referentPmo.nom + ' ' + item.referentPmo.prenom : '-' }}
                          </template>

                          <template #cell-type="{ item }">
                            {{ item.idTypeLivrable?.libTypeLivrable || '-' }}
                          </template>
                          <template #cell-createdAt="{ item }">
                            {{ item.createdAt | moment('DD-MM-YYYY HH:mm') }}
                          </template>
                        </GenericDataTable>
                      </div>
                    </div>



                  </div>
                  <div class="tab-pane" id="points-durs">
                    <div class="card">
                      <div class="card-header">
                        <h3 class="card-title">Liste des Points durs</h3>
                        <div class="card-options">
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm" @click.prevent="addPointDur(null)"><i class="fe fe-plus-circle"></i>
                              Creer<span class="caret"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        <GenericDataTable
                            ref="tablePointDurRef"
                            apiEndpoint="/pointsDurs/page"
                            :columns="pointDurColumns"
                            :filterableFields="pointDurFilterableFields"
                            :rowActions="pointDurRowActions"
                            :defaultFilters="{ idPtaId: pta.id }"
                            :search-field="'nom'"
                            @edit="editPointDur"
                            @drop="dropPointDur"
                        >
                          <template #cell-createdAt="{ item }">
                            {{ item.createdAt | moment('DD-MM-YYYY HH:mm') }}
                          </template>
                        </GenericDataTable>

                      </div>
                    </div>

                  </div>
                  <div class="tab-pane" id="risques">

                    <div class="card">
                      <div class="card-header">
                        <h3 class="card-title">Liste des Risques</h3>
                        <div class="card-options">
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm" @click.prevent="addRisque(null)"><i class="fe fe-plus-circle"></i>
                              Creer<span class="caret"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        <GenericDataTable
                            ref="tableRisqueRef"
                            apiEndpoint="/risques/page"
                            :columns="risqueColumns"
                            :filterableFields="risqueFilterableFields"
                            :rowActions="risqueRowActions"
                            :defaultFilters="{ idPtaId: pta.id }"
                            :search-field="'owner'"
                            @edit="editRisque"
                            @drop="dropRisque"
                        >
                          <template #cell-dateMaj="{ item }">
                            {{ item.dateMaj | moment('DD-MM-YYYY HH:mm') }}
                          </template>
                        </GenericDataTable>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane" id="retards">
                    <div class="card">
                      <div class="card-header">
                        <h3 class="card-title">Liste des Retards</h3>
                        <div class="card-options">
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm" @click.prevent="addRetard(null)"><i class="fe fe-plus-circle"></i>
                              Creer<span class="caret"></span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        <GenericDataTable
                            ref="tableRetardRef"
                            apiEndpoint="/retards/page"
                            :columns="retardColumns"
                            :filterableFields="retardFilterableFields"
                            :rowActions="retardRowActions"
                            :defaultFilters="{ idPtaId: pta.id }"
                            :search-field="'achevement'"
                            @edit="editRetard"
                            @drop="dropRetard"
                        >
                          <template #cell-dateMaj="{ item }">
                            {{ item.dateMaj | moment('DD-MM-YYYY HH:mm') }}
                          </template>
                        </GenericDataTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade"  id="modal-display-form" tabindex="-1" role="dialog" style="background-color: rgba(0, 0, 0, 0.5);">
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold" style="font-size: 16px;">{{ modalTitle }}</h6><button aria-label="Close" class="btn-close text-white" @click="closeModal"
                                                                                                  type="button"><span aria-hidden="true">×</span></button>
          </div>

          <div class="modal-body">
            <component
                v-if="formComponent"
                :is="formComponent"
                :value="formData"
                :type-livrables="typeLivrables"
                :phase-executions="phaseExecutions"
                :entite-traitements="entiteTraitements"
                :contacts="contacts"
                :all-poles="allPoles"
                :all-priorities="allPriorities"
                :all-status="allStatus"
                ref="formComponentRef"
                @cancel="closeModal"
                @refresh="refreshAllTabs"
            />
          </div>

          <!--          <div class="modal-footer">-->
          <!--            <button class="btn btn-gray" @click="closeModal">Annuler</button>-->
          <!--            <button class="btn btn-primary" type="submit" @click="submitCurrentForm">Valider</button>-->
          <!--          </div>-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    livrableColumns,
    livrableFilterableFields, livrableRowActions, pointDurColumns, pointDurFilterableFields, pointDurRowActions,
    retardColumns,
    retardFilterableFields,
    retardRowActions, risqueColumns, risqueFilterableFields, risqueRowActions
  } from "../../helpers/tables";
  import GenericDataTable from "../../components/GenericDataTable.vue";

  export default {
    name: "ArbitragePtaProcess",
    components: { GenericDataTable },
    props: {
      id: {
        type: [String, Number],
        required: true,
      }
    },
    data() {
      return {
        pta: null,
        formData: {},
        formComponent: null,
        modalTitle: '',

        // Données de référence chargées
        typeLivrables: [],
        phaseExecutions: [],
        entiteTraitements: [],
        contacts: [],
        allPoles: [],
        allPriorities: [],
        allStatus: [],

        // Colonnes des tableaux
        livrableColumns,
        livrableFilterableFields,
        livrableRowActions,
        pointDurColumns,
        pointDurFilterableFields,
        pointDurRowActions,
        retardColumns,
        retardFilterableFields,
        retardRowActions,
        risqueColumns,
        risqueFilterableFields,
        risqueRowActions,
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        this.$loading(true);
        console.log("Chargement PTA ID :", this.id);
        await this.getPta(this.$route.params.id);
         await this.loadAllData();
        this.$loading(false);
      },
      async getPta(id) {
        return await this.$http.get(`/pta/${id}`)
            .then(({ data }) => {
              this.pta = data;
            })
            .catch(err => {
              console.error("Erreur getPta:", err);
              throw err;
            });
      },
      async loadAllData() {
        this.$loading(true);
        try {
          await Promise.all([
            this.loadTypeLivrables(),
            this.getPhaseExecutions(),
            this.getEntiteTraitements(),
            this.getAllContacts(),
            this.getAllPoles(),
            this.getallPriorities(),
            this.getallStatuts()
          ]);
        } catch (err) {
          console.error("Erreur chargement données complémentaires :", err);
        }
        this.$loading(false);
      },

      // === API Loaders ===
      loadTypeLivrables() {
        return this.$http.get('/typeLivrables').then(({ data }) => {
          this.typeLivrables = data;
        });
      },
      getPhaseExecutions() {
        return this.$http.get('/phaseExecution').then(({ data }) => {
          this.phaseExecutions = data;
        });
      },
      getEntiteTraitements() {
        return this.$http.get('/entiteTraitement').then(({ data }) => {
          this.entiteTraitements = data;
        });
      },
      getAllContacts() {
        return this.$http.get('/contacts').then(({ data }) => {
          this.contacts = data;
        });
      },
      getAllPoles() {
        return this.$http.get('/poleAsin').then(({ data }) => {
          this.allPoles = data;
        });
      },
      getallPriorities() {
        return this.$http.get('/priorite').then(({ data }) => {
          this.allPriorities = data;
        });
      },
      getallStatuts() {
        return this.$http.get('/statutGenerique').then(({ data }) => {
          this.allStatus = data;
        });
      },

      // === Modal ===
      async openModal(type) {
        this.$loading(true);
        const modalTitleMap = {
          livrableForm: 'Formulaire du Livrable',
          pointDurForm: 'Formulaire du Point Durable',
          risqueForm: 'Formulaire du Risque',
          retardForm: 'Formulaire du Retard'
        };
        this.modalTitle = modalTitleMap[type] || 'Formulaire';

        const componentMap = {
          livrableForm: () => import('../../components/forms/LivrableForm.vue'),
          pointDurForm: () => import('../../components/forms/PointDurForm.vue'),
          risqueForm: () => import('../../components/forms/RisqueForm.vue'),
          retardForm: () => import('../../components/forms/RetardForm.vue'),
        };

        try {
          if (componentMap[type]) {
            const component = await componentMap[type]();
            this.formComponent = component.default;
          } else {
            this.formComponent = null;
          }
          $('#modal-display-form').modal('show');
        } catch (e) {
          console.error('Erreur chargement du formulaire :', e);
          this.formComponent = null;
        } finally {
          this.$loading(false);
        }
      },
      closeModal() {
        $('#modal-display-form').modal('hide');
        this.formComponent = null;
      },

      // === Helpers ===
      transformeLivrableRequest(item) {
        const formatDate = (date) => {
          if (!date) return null;
          return new Date(date).toISOString().substring(0, 10);
        };
        return {
          ...item,
          phaseConcernee: item.phaseConcernee?.idPhase || '',
          priorite: item.priorite?.priorite || '',
          anneePta: item.anneePta?.annee || '',
          referentPmo: item.referentPmo?.idContact || '',
          pointFocalAsin: item.pointFocalAsin?.idContact || '',
          pole: item.pole?.idPole || '',
          entiteCharge: item.entiteCharge?.code || '',
          datePrevueRevuePmo: formatDate(item.datePrevueRevuePmo),
        };
      },

      // === Navigation ===
      goBack() {
        if (window.history.length > 1) {
          this.$router.back();
        } else {
          this.$router.push({ name: 'arbitragePta' });
        }
      },

      // === Ajout ===
      addLivrable(livrable) {
        this.openModal("livrableForm");
        this.formData = {
          idPta : this.pta
        }

      },
      addPointDur(item) {
        this.openModal("pointDurForm");
        this.formData = {
          idPta : this.pta
        }
      },
      addRisque(item) {
        this.openModal("risqueForm");
        this.formData = {
          idPta : this.pta
        }
      },
      addRetard(item) {
        this.openModal("retardForm");
        this.formData = {
          idPta : this.pta
        }
      },

      // === Édition / Suppression ===
      editLivrable(item) {
        this.formData = this.transformeLivrableRequest(item);
        this.openModal("livrableForm");
      },
      dropLivrable(item) {
        if (confirm(`Supprimer le livrable "${item.id}" ?`)) {
          console.log("Suppression du livrable :", item);
          // this.$http.delete(`/livrable/${item.id}`).then(() => this.reloadTable());
        }
      },
      editPointDur(item) {
        this.formData = {...item}
        console.log("Édition du point dur :", item);
        this.openModal("pointDurForm");
      },
      dropPointDur(item) {
        if (confirm(`Supprimer le point dur "${item.id}" ?`)) {
          console.log("Suppression du point dur :", item);
        }
      },
      editRetard(item) {
        this.formData = {...item}
        console.log("Édition du retard :", item);
        this.openModal("retardForm");
      },
      dropRetard(item) {
        if (confirm(`Supprimer le retard "${item.id}" ?`)) {
          console.log("Suppression du retard :", item);
        }
      },
      editRisque(item) {
        this.formData = {...item}
        console.log("Édition du risque :", item);
        this.openModal("risqueForm");
      },
      dropRisque(item) {
        if (confirm(`Voulez-vous supprimer le risque "${item.id}" ?`)) {
          console.log("Suppression du risque :", item);
        }
      },
      refreshAllTabs() {
        this.$refs.tablePointDurRef?.loadData();
        this.$refs.tableLivrableRef?.loadData();
        this.$refs.tableRisqueRef?.loadData();
        this.$refs.tableRetardRef?.loadData();
      }
    }
  }
</script>
